import {
  createAsyncActionTypes,
  createActionTypes,
} from '../../util/createLifeomicActionTypes';

const actions = createActionTypes([
  'SET_ACTIVE_COHORT',
  'SET_SELECTED_COHORTS',
]);

const asyncActions = createAsyncActionTypes([
  'FETCH_COHORTS',
  'CREATE_COHORT',
  'CREATE_COHORT_ERROR',
  'UPDATE_COHORT',
  'UPDATE_COHORT_ERROR',
  'DELETE_COHORT',
  'DELETE_COHORT_ERROR',
]);

export default {
  ...actions,
  ...asyncActions,
};
